module.exports = __webpack_public_path__ + "static/media/error-system.84c5ad9d15b97bd7f065d6df5d0dd3dd.png";